import React, { createContext, useContext, useState, useEffect } from 'react';

const WarehouseThemeContext = createContext({
  theme: 'light',
  setTheme: () => {},
  isDark: false,
});

export const useWarehouseTheme = () => useContext(WarehouseThemeContext);

export const WarehouseThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check URL params first (for preview mode)
    const urlParams = new URLSearchParams(window.location.search);
    const urlTheme = urlParams.get('theme');
    if (urlTheme) return urlTheme;
    
    // Then check localStorage
    const saved = localStorage.getItem('ezwarehouse-mobile-theme');
    if (saved) return saved;
    
    // Default to light for warehouse (better for indoor warehouse work)
    return 'light';
  });

  useEffect(() => {
    localStorage.setItem('ezwarehouse-mobile-theme', theme);
  }, [theme]);

  const isDark = theme === 'dark';

  return (
    <WarehouseThemeContext.Provider value={{ theme, setTheme, isDark }}>
      <div className={`warehouse-app ${isDark ? 'warehouse-dark' : 'warehouse-light'}`}>
        {children}
      </div>
    </WarehouseThemeContext.Provider>
  );
};

export default WarehouseThemeProvider;
